import { render, staticRenderFns } from "./atendentes-recepcao.vue?vue&type=template&id=ffd691a4"
import script from "./atendentes-recepcao.vue?vue&type=script&lang=js"
export * from "./atendentes-recepcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports